
type BuildInfo = {
	TAG:string;
}

declare const BUILD_INFO: BuildInfo;
export const BuildInfo = BUILD_INFO;